import {
  CREATE_CTI_CREDENTIAL,
  GET_ALL_CTI_CREDENTIAL,
  UPDATE_ALL_CTI_CREDENTIAL,
  DELETE_CTI_CREDENTIAL,
  GET_CTI_TICKET_FIELD,
  CREATE_CTI_TICKET,
  SAVE_TICKET_FIELD,
  GET_CTI_LOG,
} from "../../api/Actions/ServiceCTI";

let initialState = {
  CreateCtiCredential: false,
  errorCreateCtiCredential: false,
  GetAllCtiCredential: false,
  errorGetAllCtiCredential: false,
  PutCtiCredential: false,
  errorPutCtiCredential: false,
  DeleteCtiCredential: false,
  errorDeleteCtiCredential: false,
  GetCtiTicketField: false,
  errorGetCtiTicketField: false,
  CreateCtiTicket: false,
  errorCreateCtiTicket: false,
  SaveCtiTicketField: false,
  errorSaveCtiTicketField: false,
  GetCtiLog: false,
  errorGetCtiLog: false,
};

export const CtiCredential = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CTI_CREDENTIAL:
      return {
        ...state,
        CreateCtiCredential: action.payload.data,
        errorCreateCtiCredential: action.payload.errorMessage,
      };
    case GET_ALL_CTI_CREDENTIAL:
      return {
        ...state,
        GetAllCtiCredential: action.payload.data,
        errorGetAllCtiCredential: action.payload.errorMessage,
      };
    case UPDATE_ALL_CTI_CREDENTIAL:
      return {
        ...state,
        PutCtiCredential: action.payload.data,
        errorPutCtiCredential: action.payload.errorMessage,
      };
    case DELETE_CTI_CREDENTIAL:
      return {
        ...state,
        DeleteCtiCredential: action.payload.data,
        errorDeleteCtiCredential: action.payload.errorMessage,
      };
    case GET_CTI_TICKET_FIELD:
      return {
        ...state,
        GetCtiTicketField: action.payload.data,
        errorGetCtiTicketField: action.payload.errorMessage,
      };
    case CREATE_CTI_TICKET:
      return {
        ...state,
        CreateCtiTicket: action.payload.data,
        errorCreateCtiTicket: action.payload.errorMessage,
      };
    case SAVE_TICKET_FIELD:
      return {
        ...state,
        CreateCtiTicket: action.payload.data,
        errorCreateCtiTicket: action.payload.errorMessage,
      };
    case GET_CTI_LOG:
      return {
        ...state,
        GetCtiLog: action.payload.data,
        errorGetCtiLog: action.payload.errorMessage,
      };
    default:
      return state;
  }
};
